module.exports = __webpack_public_path__ + "img/0Q3B8790-7_H_Wood_MockedUp.3fa8972c.jpg";